module.exports = __webpack_public_path__ + "img/head_mics_desktop.4c1bd6eb.png";